import { isBrowser } from '@zapier/common-utils';
import { getJson } from '@zapier/toolbox-browser-fetch';
import { TrackingMiddleware } from '../types';

const createMaybeAddUserId: TrackingMiddleware = config => {
  return async event => {
    // We don't want to be calling `/api/v3/profiles` from the server.
    if (!isBrowser()) {
      return;
    }

    const { baseUrl = '' } = config.get(['service', 'baseUrl']);
    const url = `${baseUrl}/api/v3/profiles`;

    try {
      const resolvedCurrentProfileId = getJson(url);
      const { active_id } = await resolvedCurrentProfileId;
      event.apply({
        userId: active_id,
      });

      event._deprecatedSetProprtiesInRoot(['userId']);
    } catch (e) {
      // ignore errors
    }
  };
};

export default createMaybeAddUserId;
